const PAGE_TITLE = 'New Move';

export default function Config($stateProvider) {
  'ngInject';
  $stateProvider.state('app.account.moves.new', {
    url: '/new',
    views: {
      '@': {
        template: `<upd-new-move></upd-new-move>`,
      },
    },
    scrollTop: true,
    title: PAGE_TITLE,
    analytics: {
      page: PAGE_TITLE,
    },
  });
}
